import { Box } from "@mui/material"
import { DynInputProps } from ".."
import UploadFileListItem from "../../UploadFileListItem"

export default function DynAttachment({
    spec,
    field,
    getFieldState
}: DynInputProps) {
    
    const { onChange, value } = field.field

    return (
        <Box
            my={1}
            border="1px solid #ccc"
            borderRadius={1}
        >
            <UploadFileListItem
                label={`${spec.label} ${spec.required ? "*" : ""}`}
                value={value}
                onChangeValue={(arquivo) => onChange(arquivo)}
                error={getFieldState(spec.name).invalid}
                hasBorder={false}
            />
        </Box>
    )
}